import React from 'react'
import { Modal, Form, Button } from 'react-bootstrap';

export default function Cooler(props) {

    const handleClose = () => {
        props.onHide(false);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const form = e.currentTarget;
        props.submitCooler(form.cooler.value);
        handleClose();
    }

    return (
        <Modal show={props.show} onHide={handleClose} className="cooler-modal" centered>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <div className="cooler-title">Personaliza tu cooler</div>
                    <div className="cooler-container">
                        <Form.Control className="cooler-input" name="cooler" defaultValue={props.defaultValue} placeholder="#PersonalizaciónAqui" />
                    </div>
                    <Button type="submit" className="cooler-button inverse">Guardar</Button>
                </Modal.Body>
            </Form>
        </Modal>
    )
}
